import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getDepts = payload => api.get('/platform/transcript/depts', payload)
const getUsers = payload => api.get('/platform/transcript/users', payload)
const getCamps = payload => api.get('/platform/transcript/camps', payload)
// accountId 走 query string（JwtAuthenticationFilter 用 getParameter() 驗證，讀不到
// POST JSON body）；陣列型資料（campaignIds/userIds/formats）才放 request body。
// 決策見後端 openspec/changes/transcript-batch-export-and-risk-level/design.md
// 「JwtAuthenticationFilter 無法驗證 POST body 內的 accountId」一節（方案 2）。
const exportDeptReports = ({ accountId, ...body }) =>
  api.post('/platform/transcript/depts/export', body, {
    params: { accountId },
    responseType: 'blob',
  })
const exportUserReports = ({ accountId, ...body }) =>
  api.post('/platform/transcript/users/export', body, {
    params: { accountId },
    responseType: 'blob',
  })
const sendDeptReports = ({ accountId, ...body }) =>
  api.post('/platform/transcript/depts/send', body, { params: { accountId } })
const sendUserReports = ({ accountId, ...body }) =>
  api.post('/platform/transcript/users/send', body, { params: { accountId } })
const getDeptEmailPreview = ({ campaignId, accountId }) =>
  api.get(`/platform/transcript/depts/${campaignId}/email-preview`, { params: { accountId } })
const getUserEmailPreview = ({ campaignId, userHisId, accountId }) =>
  api.get(`/platform/transcript/users/${userHisId}/email-preview`, {
    params: { campaignId, accountId },
  })

export default {
  getDepts,
  getUsers,
  getCamps,
  exportDeptReports,
  exportUserReports,
  sendDeptReports,
  sendUserReports,
  getDeptEmailPreview,
  getUserEmailPreview,
}
